import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loadingOverlay", "subject", "message", "submit"]

  connect() {
    this.captchaReady = false
    this.syncSubmitDisabled()
    this.hideLoadingOverlay()
  }

  captchaVerified(event) {
    this.captchaReady = Boolean(event.detail?.token)
    this.syncSubmitDisabled()
  }

  captchaCleared() {
    this.captchaReady = false
    this.syncSubmitDisabled()
  }

  hideLoadingOverlay() {
    if (!this.hasLoadingOverlayTarget) return
    this.loadingOverlayTarget.classList.add("hidden")
    this.loadingOverlayTarget.classList.remove("flex")
    this.loadingOverlayTarget.setAttribute("aria-busy", "false")
  }

  sync() {
    this.syncSubmitDisabled()
  }

  syncSubmitDisabled() {
    const subjectOk = this.hasSubjectTarget && this.subjectTarget.value.trim().length > 0
    const messageOk = this.messageTarget.value.trim().length > 0
    this.submitTarget.disabled = !(subjectOk && messageOk && this.captchaReady)
  }
}
